<template>
  <div
    v-scroll-lock
    class="animate__animated animate__fadeIn fixed inset-0 sm:py-8 flex flex-col items-center justify-center bg-black/50 z-10"
    @click.self="handleClose"
  >
    <div
      ref="content"
      class="animate__animated animate__backInDown max-w-[460px] w-full h-full flex flex-col sm:rounded-2xl overflow-y-auto bg-capino-light"
    >
      <!-- Header з більш привабливим заголовком -->
      <div class="relative w-full p-6 pb-0">
        <button
          ref="closeButton"
          class="absolute top-1 right-1 p-2 rounded-full hover:bg-gray-200 transition-colors"
          aria-label="Закрити вікно"
          @click="handleClose"
        >
          <BaseIcon icon="cross" class="text-lg text-gray-500" />
        </button>

        <div class="text-center space-y-3">
          <h1 class="text-4xl font-extrabold text-gray-900 leading-tight">
            {{ $t('payment.paywall.title') }}
          </h1>
          <p class="text-base text-gray-600 max-w-[360px] mx-auto">
            {{ $t('payment.paywall.subtitle') }}
          </p>
        </div>
      </div>

      <!-- Блок з ціною та економією -->
      <div class="px-6 pt-4">
        <div
          class="p-1 bg-gradient-to-r from-primary to-[#CE3434] rounded-2xl shadow-lg"
        >
          <div class="flex flex-col p-5 bg-white rounded-xl">
            <!-- Головна ціна та знижка -->
            <div class="flex flex-col items-center text-center relative">
              <!-- Made in Ukraine бейдж -->

              <!-- Ціна (актуальна з config/pricing) -->
              <div class="flex items-baseline gap-2">
                <span class="text-5xl font-bold text-gray-900">{{
                  paywallPrice
                }}</span>
                <span class="text-2xl font-semibold text-gray-600">{{
                  paywallCurrency
                }}</span>
              </div>

              <!-- Перекреслена ціна -->
              <!-- <div class="text-sm line-through text-gray-500 mt-1">
                Звичайна ціна: 495 грн
              </div> -->

              <!-- Пояснення -->
              <p class="mt-3 text-sm text-gray-600 max-w-[300px]">
                {{ $t('payment.paywall.description') }}
              </p>
            </div>

            <!-- Інформаційні пункти -->
            <!-- <div class="grid grid-cols-2 gap-2 text-center">
              <div class="p-2 bg-gray-50 rounded-lg">
                <div class="text-xs text-gray-500 mb-1">Тип оплати</div>
                <div class="text-sm font-medium text-gray-900">Одноразова</div>
              </div>
              <div class="p-2 bg-gray-50 rounded-lg">
                <div class="text-xs text-gray-500 mb-1">Доступ</div>
                <div class="text-sm font-medium text-gray-900">Назавжди</div>
              </div>
            </div> -->

            <!-- <div class="mt-4 pt-3 border-t border-gray-100">
              <div class="flex justify-center items-center gap-2">
                <BaseIcon icon="clock" class="text-primary" />
                <span class="text-sm font-medium text-gray-700"
                  >Знижка для перших 1000 учнів</span
                >
              </div>
            </div> -->
          </div>
        </div>
      </div>

      <!-- Список переваг -->
      <div class="px-6 py-6">
        <div class="flex flex-col gap-6">
          <div v-for="(feature, index) in features" :key="index" class="px-4">
            <div class="flex items-center gap-3">
              <div
                class="p-2 bg-primary/10 rounded-lg text-primary transition-colors"
              >
                <BaseIcon :icon="feature.icon" size="sm" />
              </div>

              <span class="text-sm font-medium text-gray-800">
                {{ feature.label }}
              </span>
            </div>
          </div>
        </div>
      </div>

      <!-- Кнопка з підказкою -->
      <div class="sticky bottom-0 px-6 py-2">
        <BaseButton
          color="primary-gradient"
          class="w-full py-4 text-lg font-bold shadow-lg hover:shadow-xl transform hover:scale-[1.01] transition-all"
          :loading="isLoading"
          @click="handleGetNow"
        >
          {{ $t('payment.paywall.getAccessNow') }}
        </BaseButton>
        <!-- <p class="mt-2 text-center text-sm text-gray-500">
          Перші 100 покупців отримають
          <span class="font-semibold text-primary">додатковий бонус</span>
        </p> -->
      </div>

      <!-- Гарантії та відгуки -->
      <div class="px-6 py-4">
        <div class="space-y-4">
          <!-- Гарантія повернення -->
          <div
            class="flex items-start gap-3 p-4 bg-white rounded-xl border border-gray-200"
          >
            <BaseIcon
              icon="refresh"
              class="text-success mt-0.5 flex-shrink-0"
            />
            <div>
              <h3 class="font-semibold text-gray-900">
                {{ $t('payment.paywall.guarantee.title') }}
              </h3>
              <p class="mt-1 text-sm text-gray-600">
                {{ $t('payment.paywall.guarantee.description') }}
              </p>
            </div>
          </div>

          <!-- Безпечна оплата -->
          <div
            class="flex items-start gap-3 p-4 bg-white rounded-xl border border-gray-200"
          >
            <BaseIcon
              icon="shield-check"
              class="text-success mt-0.5 flex-shrink-0"
            />
            <div>
              <h3 class="font-semibold text-gray-900">
                {{ $t('payment.security.securePayment') }}
              </h3>
              <p class="mt-1 text-sm text-gray-600">
                {{ $t('payment.security.protectedBy') }}
              </p>
              <div class="flex gap-2 mt-2">
                <img
                  src="/icons/privat24.png"
                  class="h-6 rounded-full"
                  alt="Privat24"
                />
                <img src="/icons/apay.png" class="h-6" alt="Apple Pay" />
                <!-- <img src="/icons/gpay.png" class="h-6" alt="PayPal" /> -->
                <!-- <img src="/icons/liqpay.png" class="h-6" alt="LiqPay" /> -->
              </div>
            </div>
          </div>

          <!-- Interface Preview Section -->
          <div class="-mx-6 pt-6">
            <h2 class="relative flex justify-center text-center">
              <span class="pt-1 text-sm font-medium text-gray-500">{{
                $t('reborn.interface')
              }}</span>

              <img
                class="w-[60px] rotate-[35deg] scale-y-[-1] opacity-50"
                src="/images/arrow-right.png"
                alt="Arrow right"
              />
            </h2>

            <!-- Image container -->
            <div class="w-full h-[70vh] pl-4 pb-4">
              <img
                :src="interfaceImageSrc"
                alt="Capino App Interface"
                class="h-full w-full max-w-full mx-auto object-cover object-left rounded-l-lg shadow-xl"
              />
            </div>
          </div>

          <!-- FAQ Section -->
          <PaymentPaywallModalFaq />

          <!-- Відгуки -->
          <!-- <div class="p-4 bg-white rounded-xl border border-gray-200">
            <div class="flex items-center gap-2">
              <div class="flex">
                <BaseIcon
                  icon="star-filled"
                  class="text-yellow-400"
                  v-for="i in 5"
                  :key="i"
                />
              </div>
              <span class="text-sm font-medium text-gray-700"
                >4.9/5 (1,234 відгуки)</span
              >
            </div>
            <div class="mt-2 pl-1 border-l-2 border-primary">
              <p class="text-sm italic text-gray-600">
                "Капіно допоміг моїй дитині підготуватись до ЗНО на 190 балів!"
              </p>
              <p class="mt-1 text-xs text-gray-500">- Анна, мама учня</p>
            </div>
          </div> -->

          <!-- Блок із посиланнями -->
          <div class="py-4 text-center text-sm text-gray-500">
            <router-link
              v-if="currentLocale === 'en'"
              class="hover:underline"
              target="_blank"
              :to="{ name: 'public.terms-of-services' }"
            >
              {{ $t('footer.termsOfUse') }}.
            </router-link>

            <router-link
              v-else
              class="hover:underline"
              target="_blank"
              :to="{ name: 'public.offer' }"
            >
              {{ $t('footer.links.publicOffer') }}.
            </router-link>

            <router-link
              class="hover:underline"
              target="_blank"
              :to="{ name: 'public.privacy-policy' }"
            >
              {{ $t('footer.links.privacyPolicy') }}.
            </router-link>
          </div>

          <div class="flex justify-center">
            <span class="text-center text-[10px] text-gray-500">
              <span>© {{ new Date().getFullYear() }} Capino.</span>
              <img
                src="/images/capybara-white-small.png"
                class="w-4 h-4 mx-2 mb-1 inline-flex"
                loading="lazy"
              />
              <span>{{ $t('footer.copyright') }}</span>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations } from 'vuex'
import * as motion from 'motion'

import * as services from '@/services'

import BaseButton from '@/components/Base/BaseButton.vue'
import PaymentPaywallModalFaq from './PaymentPaywallModalFaq.vue'

export default {
  name: 'PaymentTariffsModal',

  components: { BaseButton, PaymentPaywallModalFaq },

  data: () => ({
    isLoading: false
  }),

  mounted() {
    this.$store.dispatch('pricing/FETCH_PRICE')
  },

  computed: {
    ...mapState('user', ['user']),
    ...mapGetters('auth', ['isAuthorized']),
    ...mapGetters('locale', ['currentLocale']),
    ...mapGetters('pricing', ['priceUsd', 'priceUah']),

    paywallPrice() {
      return this.currentLocale === 'uk' ? String(this.priceUah) : String(this.priceUsd)
    },
    paywallCurrency() {
      return this.currentLocale === 'uk' ? 'грн' : '$'
    },

    features() {
      return [
        {
          icon: 'book',
          title: this.$t('payment.features.materials'),
          label: this.$t('payment.features.materialsDescription')
        },
        {
          icon: 'chart-line-up',
          title: this.$t('payment.features.results'),
          label: this.$t('payment.features.resultsDescription')
        },
        {
          icon: 'brain-circuit',
          title: this.$t('payment.features.explanations'),
          label: this.$t('payment.features.explanationsDescription')
        }
      ]
    },

    interfaceImageSrc() {
      return this.currentLocale === 'uk'
        ? '/images/big-interface-uk.png'
        : '/images/big-interface-en.png'
    }
  },

  methods: {
    ...mapMutations('ui', {
      setUiAuthModal: 'SET_UI_AUTH_MODAL'
    }),

    handleClose() {
      const el = this.$el

      this.$refs.content.classList.add('animate__backOutDown')

      motion
        .animate(el, { opacity: 0 }, { duration: 0.3 })
        .finished.then(() => {
          this.$emit('close')
        })
    },

    handleGetNow() {
      if (this.user?.isPremium) {
        this.$router.push({ name: 'hub.sections' })
        this.handleClose()
      } else if (this.isAuthorized) {
        this.openCheckout()
      } else {
        this.setUiAuthModal({
          isVisible: true,
          componentCode: 'registration',
          onSuccess: this.openCheckout
        })
      }
    },

    async openCheckout() {
      if (this.user?.isPremium) {
        this.handleClose()
        this.$router.push({ name: 'hub.sections' })
        return
      }

      this.isLoading = true

      try {
        const { content } = await services.payments.liqpayCheckout({
          locale: this.currentLocale
        })

        localStorage.setItem('pendingOrderId', content.orderId)

        // Redirect directly to payment gateway
        window.location.href = content.link
      } catch (e) {
        console.error('Failed to initiate checkout:', e)
        // alert(this.$t('payment.error.somethingWentWrong'))
      } finally {
        this.isLoading = false
      }
    }
  }
}
</script>
